module.exports = __webpack_public_path__ + "media/icons/check-circle-broken-green-f2a5d018.svg";